// Very simple accordion, no fancy animations
const accordionHeader = document.querySelectorAll(".accordion__header");
const accordionContent = document.querySelectorAll(".accordion__content");

for (let i = 0; i < accordionHeader.length; i++) {
  accordionHeader[i].addEventListener("click", function () {
    const classes = !this.classList.contains("is-active");

    for (let i = 0; i < accordionHeader.length; i++) {
      accordionHeader[i].classList.remove("is-active");
    }

    for (let i = 0; i < accordionContent.length; i++) {
      accordionContent[i].classList.remove("is-active");
    }

    if (classes) {
      this.classList.toggle("is-active");
      this.nextElementSibling.classList.toggle("is-active");
    }
  });
}
